"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackTrayItem = exports.Styled = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const atoms_1 = require("../atoms");
const TrayItem_1 = require("./TrayItem");
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
exports.Styled = styled_components_1.default.div `
    visibility: ${(p) => (p.menuOpen ? 'visible' : 'hidden')};
    color: ${(p) => p.theme.palette.text.primary};
    padding: 0px 16px;
    font-size: 12px;
    letter-spacing: 1.05px;
    line-height: 16px;
    display: inline-block;
    text-transform: uppercase;
    text-decoration: none;
    text-align: left;
    height: ${TrayItem_1.trayItemHeight}px;
    ${(p) => p.theme.breakpoints.down('xs')} {
        height: ${TrayItem_1.xsTrayItemHeight}px;
    }
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    white-space: nowrap;
    background: ${(p) => p.theme.palette.background.paper};
    cursor: pointer;

    &:hover {
        visibility: visible;
        > .arrow-wrap {
            transform: translate3d(0, 0, 0) translateX(-4px);
        }
    }

    > .arrow-wrap {
        left: 16px;
        height: 100%;
		display: flex;
        align-items: center;
    }

    .back-tray-title {
        margin-left: 32px;
        height: 100%;
		display: flex;
        align-items: center;
    }
`;
const BackTrayItem = ({ toggleMenu, onKeyUp, menuOpen }) => {
    const { messages } = (0, shared_1.useMessages)();
    const label = messages.back || 'Back';
    return (react_1.default.createElement(exports.Styled, { tabIndex: 0, role: "menuitem", onClick: toggleMenu, menuOpen: menuOpen, onKeyUp: onKeyUp, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick },
        react_1.default.createElement("span", { className: "back-tray-title" }, label),
        react_1.default.createElement(atoms_1.ArrowIcon, { face: "left", hoverDirection: "left" })));
};
exports.BackTrayItem = BackTrayItem;
//# sourceMappingURL=BackTrayItem.js.map